import { render, staticRenderFns } from "./MedicalCare.vue?vue&type=template&id=697b68b8&"
import script from "./MedicalCare.vue?vue&type=script&lang=js&"
export * from "./MedicalCare.vue?vue&type=script&lang=js&"
import style0 from "./MedicalCare.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports